import { render } from "./VMain.vue?vue&type=template&id=56c70f44"
import script from "./VMain.vue?vue&type=script&lang=js"
export * from "./VMain.vue?vue&type=script&lang=js"

import "./VMain.vue?vue&type=style&index=0&id=56c70f44&lang=scss"

import exportComponent from "E:\\Project\\Vue\\keep-calm\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__